import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { useNavigate } from 'react-router-dom'
import { getSingleDataFromDatabase, userUploadProfilePicAPI } from '../utils/api'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { BASEURLS } from '../utils/BaseUrl'
import moment from 'moment'
import { MdCloudUpload } from 'react-icons/md'
import { FaCertificate, FaShieldAlt, FaShoppingCart, FaStar, FaTrophy } from 'react-icons/fa'

const MyProfile = () => {
    const ppcid = localStorage.getItem('ppcdata');
    const [ppc, setPPC] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsloading] = useState(false);
    const [file, setFile] = useState('');

    useEffect(() => {
        if (ppcid) {
            getDashboardSingleEmpData(ppcid);
        }
        else {
            navigate("/");
        }
    }, [ppcid]);

    const getDashboardSingleEmpData = (ppcid) => {
        setIsloading(true);
        getSingleDataFromDatabase(`ppc-get-single-data/${ppcid}`).then((res) => {
            if (res.data.status === 1) {
                setIsloading(false);
                setPPC(...[res.data.ppcdata]);
            }
            else {
                setIsloading(true);
                toast.error("Check you connection");
            }
        })
    }
    // Update Image
    useEffect(() => {
        if (file) {
            try {
                const data = new FormData();
                data.append("ppc_foto", file);
                userUploadProfilePicAPI(`ppc-update-profile-picture-data/${ppcid}`, data).then((res) => {
                    if (res.data.status === 1) {
                        window.location.reload();
                        toast.success("profile pic updated successfully");
                    }
                    else {
                        toast.error("Unable to fetched picture data");
                    }
                })
            }
            catch (error) {
                toast.error("Connection failed!!")
            }
        }
    }, [file]);

    const tierText = ppc?.tier || 'Platinum';
    const deliveryPct = ppc?.last_week_delivery_rate ?? 75;

    return (
        <div className="myprofile">
            <Helmet>
                <title>SATKARTAR:DISPATCH::MY PROFILE</title>
            </Helmet>
            <ContentWrapper>
                <div className="row">
                    <div className="col-12 col-lg-6 col-xl-8" style={{ paddingLeft: "unset" }}>
                        <div className="card radius-10 overflow-hidden w-100 profile-card">
                            <div className="card-header border-bottom bg-transparent d-flex align-items-center justify-content-between">
                                <h6 className="mb-0 heading">My Profile</h6>
                            </div>

                            {isLoading ? (
                                <div className="myprofilesection">
                                    <div className="row">
                                        <div className="col-12 col-lg-4 col-xl-4">
                                            <Skeleton width={260} height={260} />
                                        </div>
                                        <div className="col-12 col-lg-8 col-xl-8">
                                            {[...Array(8)].map((_, i) => (
                                                <Skeleton key={i} style={{ marginBottom: 10 }} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="myprofilesection">
                                    {/* LEFT: Avatar card */}
                                    <div className="col-12 col-lg-4 col-xl-4">
                                        <div className="avatar-tile">
                                            <div className="avatar-wrap">
                                                <img src={BASEURLS(ppc?.ppc_foto)} alt="profile" />
                                            </div>

                                            {/* Badge chips (like screenshot) */}
                                            <div className="chips">
                                                <span className="chip"><FaShieldAlt /> Consistency Champ II</span>
                                                <span className="chip"><FaCertificate /> RC Master II</span>
                                                <span className="chip"><FaShoppingCart /> AOV Boss I</span>
                                            </div>

                                            {/* Upload */}
                                            <label className="upload-btn" htmlFor="ppc_foto">
                                                <MdCloudUpload />
                                                &nbsp; Change Profile Picikiller
                                            </label>
                                            <input
                                                className="profilePic"
                                                type="file"
                                                id="ppc_foto"
                                                name="ppc_foto"
                                                accept="image/*"
                                                onChange={(e) => setFile(e.target.files[0])}
                                            />
                                        </div>
                                    </div>

                                    {/* RIGHT: Details */}
                                    <div className="col-12 col-lg-8 col-xl-8">
                                        {/* Name row */}
                                        <div className="name-row">
                                            <span className="tier-pill">{tierText}</span>
                                            <h2 className="agent-name">
                                                {ppc?.ppc_name} <FaStar className="name-star" />
                                            </h2>
                                        </div>

                                        {/* Info grid */}
                                        <div className="info-list">
                                            <div className="item">
                                                <span className="key">Email ID:</span>
                                                <span className="value">{ppc?.ppc_email}</span>
                                            </div>
                                            <div className="item">
                                                <span className="key">Mobile Number:</span>
                                                <span className="value">{ppc?.ppc_mobile}</span>
                                            </div>
                                            <div className="item">
                                                <span className="key">Last Login:</span>
                                                <span className="value">
                                                    {ppc?.ppc_last_login
                                                        ? moment(ppc?.ppc_last_login).format('Do MMMM YYYY')
                                                        : '1st August 2025'}
                                                </span>
                                            </div>
                                            <div className="item">
                                                <span className="key">Account Create Date:</span>
                                                <span className="value">
                                                    {ppc?.created_at
                                                        ? moment(ppc?.created_at).format('Do MMMM YYYY')
                                                        : '1st August 2025'}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Achievement strip */}
                                        <div className="achievement">
                                            <FaTrophy className="text-warning" size={20} style={{ marginRight: "10px" }} />
                                            <span className="text" style={{ letterSpacing: "0.6px" }}>
                                                Achieved <strong>{deliveryPct}%</strong> call rate last week
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default MyProfile